/**
 * Off-canvas navigation (sections/off-canvas.blade.php), used below 1200px.
 * Rail on the left lists the top-level items, the detail area shows the
 * groups of the active item. On phones only one level is visible at a time.
 */
const PHONE = window.matchMedia('(max-width: 560px)');
const DESKTOP = window.matchMedia('(min-width: 1200px)');

const initOffCanvas = () => {
  const root = document.querySelector('[data-offcanvas]');
  if (!root) {
    return;
  }

  // Left-overs of the former Custom-HTML widget, should it still be active.
  const removeLegacy = () => document.querySelectorAll('.ocb2-veil, .ocb2-drawer').forEach((el) => el.remove());
  removeLegacy();

  const body = document.body;
  const drawer = root.querySelector('.offcanvas');
  const title = root.querySelector('[data-offcanvas-title]');
  const panels = Array.from(root.querySelectorAll('[data-offcanvas-panel]'));
  const items = Array.from(root.querySelectorAll('[data-offcanvas-item]'));
  const burgers = document.querySelectorAll('.js__openmenu, .mega-menu-toggle');
  let current = 0;

  const setExpanded = (open) => {
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('.js__openmenu').forEach((el) => el.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };

  const render = (index) => {
    current = index;
    panels.forEach((panel) => {
      panel.hidden = Number(panel.dataset.offcanvasPanel) !== index;
    });
    items.forEach((item) => {
      item.classList.toggle('is-active', Number(item.dataset.offcanvasItem) === index);
    });
    const active = panels.find((panel) => Number(panel.dataset.offcanvasPanel) === index);
    title.textContent = active?.dataset.offcanvasPanelTitle || '';
  };

  const open = () => {
    removeLegacy();
    body.classList.remove('offcanvas-sub', 'ocb2-open', 'mobilemenu-open');
    document.documentElement.classList.remove('noscroll');
    render(current);
    body.classList.add('offcanvas-open');
    setExpanded(true);
  };

  const close = () => {
    body.classList.remove('offcanvas-open', 'ocb2-open');
    setExpanded(false);
    window.setTimeout(() => body.classList.remove('offcanvas-sub'), 440);
  };

  const activate = (index) => {
    if (!body.classList.contains('offcanvas-open')) {
      render(index);
      body.classList.add('offcanvas-open');
      setExpanded(true);
      if (PHONE.matches) {
        body.classList.add('offcanvas-sub');
      }
      return;
    }

    if (PHONE.matches) {
      render(index);
      body.classList.add('offcanvas-sub');
      return;
    }

    const cols = panels.find((panel) => !panel.hidden);
    cols?.classList.add('is-out');
    window.setTimeout(() => {
      render(index);
      panels.forEach((panel) => panel.classList.remove('is-out'));
    }, 170);
  };

  root.addEventListener('click', (event) => {
    const item = event.target.closest('[data-offcanvas-item]');
    if (item) {
      activate(Number(item.dataset.offcanvasItem));
      return;
    }
    if (event.target.closest('[data-offcanvas-close]')) {
      close();
      return;
    }
    if (event.target.closest('[data-offcanvas-back]')) {
      body.classList.remove('offcanvas-sub');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !body.classList.contains('offcanvas-open')) {
      return;
    }
    if (PHONE.matches && body.classList.contains('offcanvas-sub')) {
      body.classList.remove('offcanvas-sub');
    } else {
      close();
    }
  });

  // The header burger (and Max Mega Menu's own toggle) open the drawer; the
  // capture phase keeps menu.js from toggling the old mobile menu.
  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.js__openmenu, .mega-menu-toggle')) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (body.classList.contains('offcanvas-open')) {
        close();
      } else {
        open();
      }
    },
    true
  );

  burgers.forEach((burger) => burger.setAttribute('aria-controls', 'aa-offcanvas'));

  const onDesktop = (event) => {
    if (event.matches) {
      body.classList.remove('offcanvas-open', 'offcanvas-sub');
      setExpanded(false);
    }
  };
  if (DESKTOP.addEventListener) {
    DESKTOP.addEventListener('change', onDesktop);
  } else {
    DESKTOP.addListener(onDesktop);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOffCanvas);
} else {
  initOffCanvas();
}
